<mat-card class="agent-data">
  <ng-template #action>
    <ng-container class="headline-action-button">
      <button
        [matMenuTriggerFor]="menu"
        mat-button
        class="action-button"
        aria-label="Open menu"
        [disabled]="isActionsDisabled"
      >
        <span class="mat-button-wrapper"><i class="material-icons">more_horiz</i></span>
      </button>
      <mat-menu #menu="matMenu">
        <button class="mat-menu-item-btn" mat-menu-item (click)="onBulkRemove()">
          <span>Remove</span>
        </button>
      </mat-menu>
    </ng-container>
  </ng-template>
  <div class="unman-device-wait-dialog" *ngIf="showWaitDialog">
    <div class="progress-container">
      <mat-progress-bar mode="determinate" [value]="waitProgress"></mat-progress-bar>
      <div class="progress-message">{{ waitMsg }}</div>
      <button mat-button mat-stroked-button (click)="cancelWaitDialog()">CANCEL</button>
    </div>
  </div>
  <progress-spinner *ngIf="isLoading"> </progress-spinner>
  <div *ngIf="table && table.columns && table.columns.length > 0" class="datasource-table">
    <viavi-table
      [tableConfigurations]="table"
      [isActionEnabled]="hasReadWriteRole"
      [template]="action"
      [resetCheckbox]="resetCheckbox"
      (sendRowAction)="onRowActionClick($event)"
    >
    </viavi-table>
  </div>
</mat-card>
